// Homepage only: the header starts transparent over the hero and turns solid once the page scrolls.
// Toggles [data-scrolled] on header[data-transparent-header]; styling lives in layout/theme.liquid.
const header = document.querySelector('header[data-transparent-header]');
if (header) {
  const update = () => header.toggleAttribute('data-scrolled', window.scrollY > 8);
  update();
  window.addEventListener('scroll', update, { passive: true });
}

// Exposes the announcement bar's height as --announcement-h so the homepage hero can fill the rest of the screen.
const announcement = document.querySelector('[data-announcement]');
if (announcement) {
  const setHeight = () => document.documentElement.style.setProperty('--announcement-h', `${announcement.offsetHeight}px`);
  setHeight();
  new ResizeObserver(setHeight).observe(announcement);
}

// Exposes the sticky header's height as --header-h so pinned homepage media (parallax chapters) can sit just below it.
if (header) {
  const setHeaderH = () => document.documentElement.style.setProperty('--header-h', `${header.offsetHeight}px`);
  setHeaderH();
  new ResizeObserver(setHeaderH).observe(header);
}
